import { filter } from 'lodash';

import { useEffect, useRef, useState } from 'react';
// @mui
import {
  Autocomplete,
  Box,
  Button,
  CircularProgress,
  Container,
  FormControlLabel,
  Grid,
  IconButton,
  Paper,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
  Typography,
} from '@mui/material';
import Alert from '@mui/material/Alert';
import Checkbox from '@mui/material/Checkbox';
import Snackbar from '@mui/material/Snackbar';
// components

import Iconify from '../iconify';
// sections
// mock
// import USERLIST from '../_mock/user';
import { useNavigate, useParams } from 'react-router-dom';
import { CreateTasks, GetDepartments, GetUsersList } from 'src/components/services/httpServices';

import { Country } from 'country-state-city';
import { Trash } from 'react-feather';
import ClientDetails from 'src/pages/Clients/ClientDetails';
import CompanyDetails from 'src/pages/Company/CompanyDetails';
import TasksListAgainstClient from './TasksListAgainstClient';
// ----------------------------------------------------------------------

const TABLE_HEAD = [
  { id: 'no', label: 'Id', alignRight: false },
  { id: 'activityName', label: 'Title', alignRight: false },
  { id: 'activityDate', label: 'Activity Date', alignRight: false },
  { id: 'deadLine', label: 'Dead Line', alignRight: false },
  { id: 'comments', label: 'Details', alignRight: false },
  // { id: 'AssignedToUserId', label: 'Pending At', alignRight: false },
  { id: 'status', label: 'Status', alignRight: false },
  { id: 'deptId', label: 'Send to Department', alignRight: false },
  { id: 'assignedToUserId', label: 'Assigned to Agent', alignRight: false },
  { id: '', label: 'Action', alignRight: false },
  // { id: 'MstActivityId', label: 'Activity Id', alignRight: false },
  //   { id: '' },
];

// ----------------------------------------------------------------------

// ----------------------------------------------------------------------

function descendingComparator(a, b, orderBy) {
  if (b[orderBy] < a[orderBy]) {
    return -1;
  }
  if (b[orderBy] > a[orderBy]) {
    return 1;
  }
  return 0;
}

function getComparator(order, orderBy) {
  return order === 'desc'
    ? (a, b) => descendingComparator(a, b, orderBy)
    : (a, b) => -descendingComparator(a, b, orderBy);
}

function applySortFilter(array, comparator, query) {
  //console.log('sdsds', array);
  const stabilizedThis = array.map((el, index) => [el, index]);
  stabilizedThis.sort((a, b) => {
    const order = comparator(a[0], b[0]);
    if (order !== 0) return order;
    return a[1] - b[1];
  });
  if (query) {
    return filter(array, (_user) => _user.activityName.toLowerCase().indexOf(query.toLowerCase()) !== -1);
  }
  return stabilizedThis.map((el) => el[0]);
}

export default function TasksList(props) {
  let { id, checkClient } = useParams();

  const [page, setPage] = useState(0);

  const [order, setOrder] = useState('desc');

  const [selected, setSelected] = useState([]);

  const [orderBy, setOrderBy] = useState('id');

  const [filterName, setFilterName] = useState('');

  const [rowsPerPage, setRowsPerPage] = useState(25);
  const [tasks, setTasks] = useState([]);

  const [selectedRow, setSelectedRow] = useState(null);
  const [loading, setLoading] = useState(true);
  const [departments, setDepartments] = useState([]);
  const [users, setUsers] = useState([]);
  const [usersOfDept, setUsersOfDept] = useState([]);
  const [selectedDepartment, setSelectedDepartment] = useState(null);
  const [selectedUser, setSelectedUser] = useState(null);
  const navigate = useNavigate();
  const [isInCanada, setIsInCanada] = useState(false);
  const [isWorkingWithEmp, setIsWorkingWithEmp] = useState(false);
  const [saved, setSaved] = useState(false);
  const [open, setOpen] = useState(false);
  const [vertical, setVertical] = useState('bottom');
  const [horizontal, setHorizontal] = useState('right');
  const [selectedCountry, setSelectedCountry] = useState(null);
  const [clientsForEmp, setClientsforEmp] = useState([]);
  const [message, setMessage] = useState('');
  const activityNameRef = useRef('');
  const activityCommentsRef = useRef('');
  const deadLineRef = useRef('');
  const startDateRef = useRef('');
  const prospectEmailRef = useRef('');
  const prospectNameRef = useRef('');
  const invoiceNoRef = useRef('');
  const statusRef = useRef('');
  useEffect(() => {
    //console.log('tasks:', tasks);
    const fetch = async () => {
      const response = await GetDepartments();
      const users = await GetUsersList();
      if (response !== null) {
        setDepartments(response);
        setUsers(users);
        // setTasks(tasks);
        setLoading(false);
      }
    };
    fetch();
  }, []);
  const rowClicked = async (row) => {
    setSelectedRow(row);
  };

  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === 'asc';
    setOrder(isAsc ? 'desc' : 'asc');
    setOrderBy(property);
  };

  const handleSelectAllClick = (event) => {
    if (event.target.checked) {
      const newSelecteds = tasks.map((n) => n.no);
      setSelected(newSelecteds);
      return;
    }
    setSelected([]);
  };

  const handleClick = (event, id) => {
    const selectedIndex = selected.indexOf(id);
    let newSelected = [];
    if (selectedIndex === -1) {
      newSelected = newSelected.concat(selected, id);
    } else if (selectedIndex === 0) {
      newSelected = newSelected.concat(selected.slice(1));
    } else if (selectedIndex === selected.length - 1) {
      newSelected = newSelected.concat(selected.slice(0, -1));
    } else if (selectedIndex > 0) {
      newSelected = newSelected.concat(selected.slice(0, selectedIndex), selected.slice(selectedIndex + 1));
    }
    setSelected(newSelected);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setPage(0);
    setRowsPerPage(parseInt(event.target.value, 10));
  };

  const handleFilterByName = (event) => {
    setPage(0);
    setFilterName(event.target.value);
  };

  const onAddClientBtnClick = () => {
    if (prospectNameRef?.current?.value == '' || prospectEmailRef?.current?.value == '') {
      alert('Please add Client Name & Email');
    } else {
      const clientRow = {
        no: clientsForEmp.length + 1,
        clientName: prospectNameRef?.current?.value,
        clinetEmail: prospectEmailRef?.current?.value,
        invoiceNumber: invoiceNoRef?.current?.value,
        isInCanada: isInCanada,
        status: statusRef?.current?.value,
        outSideCountry: selectedCountry?.name,
        isWorkingWithEmployer: isWorkingWithEmp,
        startDate: startDateRef?.current?.value,
      };
      setClientsforEmp((prev) => [...prev, clientRow]);

      prospectNameRef.current.value = '';
      prospectEmailRef.current.value = '';
      invoiceNoRef.current.value = '';
      if (isInCanada) {
        statusRef.current.value = '';
        startDateRef.current.value = '';
        setIsInCanada(false);
        setIsWorkingWithEmp(false);
      }
      setSelectedCountry(null);
    }
  };

  const removeClientsForEmpRow = (index) => {
    console.log('index:', index);
    const newList = [...clientsForEmp];
    newList.splice(index, 1);
    //  console.log('new List', newList);

    // setGrandTotal(parseInt(grandTotal) - price * quantity);
    setClientsforEmp(newList);
  };
  const onAddTaskBtnClick = async (event) => {
    event.preventDefault();
    let task = {
      no: tasks.length + 1,
      activityName: activityNameRef?.current?.value,
      comments: activityCommentsRef?.current?.value,
      deptId: selectedDepartment?.key,
      activityDate: new Date().toJSON(),
      status: 'Pending',
      assignedToUserId: selectedUser?.id,
      assignedToUserName: selectedUser?.name,
      deadLine: deadLineRef?.current?.value,
      prospectStatus: statusRef?.current?.value,
      prospectName: prospectNameRef?.current?.value,
      prospectEmail: prospectEmailRef?.current?.value,
      invoiceNo: invoiceNoRef?.current?.value,
      isInsideCanada: isInCanada,
      isWorkingWithEmp: isWorkingWithEmp,
      WorkingStartDate: startDateRef?.current?.value,
      prospectCountry: selectedCountry?.name,
      subActivitysClients: clientsForEmp,
    };
    let savedTasks = [];

    if (activityNameRef.current.value == '') {
      alert('Please add Titile');
    } else if (activityCommentsRef.current.value == '') {
      alert('Please add Details');
    } else if (selectedDepartment == null) {
      alert('Please select Department');
    } else if (deadLineRef.current.value == '') {
      alert('Please select Dead Line');
    }
    // else if (selectedUser == null) {
    //   alert('Please select Agent');
    // }
    else {
      setTasks((prev) => [...prev, task]);
      //props.setTasks((prev) => [...prev, task]);
      savedTasks.push(task);
      activityNameRef.current.value = '';
      activityCommentsRef.current.value = '';
      deadLineRef.current.value = '';
    }
    await SaveTasks(savedTasks);
    // console.log('savedTasks:', savedTasks);
  };

  const SaveTasks = async (savedTasks) => {
    if (savedTasks?.length > 0) {
      // console.log('llalalal', tasks);
      setLoading(true);
      var payload = savedTasks;

      // console.log(payload);
      let response = await CreateTasks(id, checkClient, payload);
      //  console.log('PostResponse:', response);
      if (response.status == 200) {
        setTasks([]);
        props.setMessage(response.data);
        props.setSaved(true);
        props.setOpen(true);
        setLoading(false);
        setTimeout(() => {
          if (checkClient) {
            navigate('/app/Clients');
          } else {
            navigate('/app/Companies');
          }
        }, 2000);
      } else {
        props.setMessage(response?.data);
        props.setSaved(false);
        props.setOpen(true);
        setLoading(false);
        // setPosting(false);
      }
    } else {
      alert('Add tasks into list first.');
    }
  };
  const deleteRow = (no) => {
    const newList = tasks.filter((item) => item.no !== no);

    setTasks(newList);
    //props.setTasks(newList);
  };

  const emptyRows = page > 0 ? Math.max(0, (1 + page) * rowsPerPage - tasks.length) : 0;

  const filteredUsers = applySortFilter(tasks, getComparator(order, orderBy), filterName);

  const isNotFound = !filteredUsers.length && !!filterName;
  // console.log('Userssss:', users);
  // console.log('selectedDepartment:', selectedDepartment);
  // console.log('selectedUser:', selectedUser);

  const handleDepartmentChangeClick = (event, department) => {
    setSelectedDepartment(department);
    const userList = users.filter((e) => e.deptId == department.key);
    setUsersOfDept(userList);
  };
  const handleClose = () => {
    setOpen(false);
  };
  const handleChangeInCanada = (event) => {
    setIsInCanada(event.target.value);
  };

  console.log('selectedCountry:', selectedCountry);
  console.log('checkClient:', checkClient);
  return (
    <>
      <Container>
        <Stack direction="row" alignItems="center" justifyContent="space-between" mb={5} marginTop={4}>
          <Typography variant="h4" gutterBottom>
            Create Tasks
          </Typography>

          <Stack direction="row" spacing={2}>
            <Button
              variant="contained"
              disabled={loading}
              onClick={onAddTaskBtnClick}
              startIcon={<Iconify icon="eva:plus-fill" />}
            >
              Save
            </Button>
            {/* <Button variant="contained" onClick={SaveTasks}>
              Save
            </Button> */}
            {/* <Button
              variant="contained"
              onClick={() => {
                navigate(-1);
              }}
            >
              Back
            </Button> */}
          </Stack>
        </Stack>
        {false ? (
          <Grid display="flex" alignItems="center" justifyContent="center" height="40vh" container>
            <CircularProgress size={60} thickness={3} value={100} />
          </Grid>
        ) : (
          <Grid container spacing={3}>
            <Grid item xs={12}>
              <Box component={Paper} p={4}>
                <Grid container spacing={3}>
                  <Grid item xs={12} sm={4} md={3}>
                    <TextField
                      label="Title"
                      required
                      variant="outlined"
                      fullWidth
                      size="small"
                      inputRef={activityNameRef}
                    />
                  </Grid>

                  <Grid item xs={12} sm={4} md={3}>
                    <TextField
                      label="Details"
                      required
                      variant="outlined"
                      fullWidth
                      size="small"
                      inputRef={activityCommentsRef}
                    />
                  </Grid>
                  <Grid item xs={12} sm={4} md={3}>
                    <TextField
                      label="Dead Line"
                      variant="outlined"
                      fullWidth
                      required
                      size="small"
                      type="date"
                      // defaultValue={user.userEmail}
                      inputRef={deadLineRef}
                      InputLabelProps={{ shrink: true }}
                    />
                  </Grid>
                  <Grid item xs={12} sm={4} md={3}>
                    <Autocomplete
                      id="department"
                      size="small"
                      options={departments}
                      // defaultValue={departments.find((e) => e.key == user.deptId)}
                      getOptionLabel={(department) => department.value}
                      renderInput={(params) => (
                        <TextField required {...params} label="Send to Department" variant="outlined" />
                      )}
                      onChange={(event, department) => handleDepartmentChangeClick(event, department)}
                    />
                  </Grid>
                  <Grid item xs={12} sm={4} md={3}>
                    <Autocomplete
                      id="users"
                      size="small"
                      options={usersOfDept}
                      // defaultValue={departments.find((e) => e.key == user.deptId)}
                      getOptionLabel={(user) => user.name}
                      renderInput={(params) => <TextField {...params} label="Assigned to Agent" variant="outlined" />}
                      onChange={(event, user) => setSelectedUser(user)}
                    />
                  </Grid>
                  <Grid item xs={12} sm={8} md={8}></Grid>
                  {checkClient == 'false' ? (
                    <>
                      <Grid item xs={12} sm={12} md={12}>
                        <Stack
                          direction="row"
                          alignItems="center"
                          justifyContent="space-between"
                          md={5}
                          marginTop={4}
                          spacing={2}
                        >
                          <Typography variant="h6" gutterBottom>
                            Add Clients
                          </Typography>
                          <Button
                            variant="contained"
                            onClick={onAddClientBtnClick}
                            startIcon={<Iconify icon="eva:plus-fill" />}
                          >
                            Add
                          </Button>
                        </Stack>
                      </Grid>

                      <Grid item xs={12} sm={4} md={3}>
                        <TextField
                          label="Client's Name"
                          variant="outlined"
                          fullWidth
                          required
                          size="small"
                          inputRef={prospectNameRef}
                        />
                      </Grid>
                      <Grid item xs={12} sm={4} md={3}>
                        <TextField
                          label="Client's Email"
                          variant="outlined"
                          required
                          fullWidth
                          size="small"
                          inputRef={prospectEmailRef}
                        />
                      </Grid>
                      <Grid item xs={12} sm={4} md={3}>
                        <TextField
                          label="Invoice Number"
                          variant="outlined"
                          fullWidth
                          size="small"
                          inputRef={invoiceNoRef}
                        />
                      </Grid>

                      <Grid item xs={12} sm={4} md={3}>
                        <FormControlLabel
                          control={
                            <Checkbox
                              checked={isInCanada}
                              onChange={() => setIsInCanada(!isInCanada)}
                              inputProps={{ 'aria-label': 'controlled' }}
                            />
                          }
                          label="In-Side Canada"
                          labelPlacement="start"
                        />
                      </Grid>
                      {isInCanada ? (
                        <>
                          <Grid item xs={12} sm={4} md={3}>
                            <TextField label="Status" variant="outlined" fullWidth size="small" inputRef={statusRef} />
                          </Grid>

                          <Grid item xs={12} sm={4} md={3}>
                            <FormControlLabel
                              control={
                                <Checkbox
                                  checked={isWorkingWithEmp}
                                  onChange={() => setIsWorkingWithEmp(!isWorkingWithEmp)}
                                  inputProps={{ 'aria-label': 'controlled' }}
                                />
                              }
                              label="Is Working With Employer"
                              labelPlacement="start"
                            />
                          </Grid>
                          {isWorkingWithEmp ? (
                            <Grid item xs={12} sm={4} md={3}>
                              <TextField
                                label="Start Date"
                                variant="outlined"
                                fullWidth
                                type="date"
                                size="small"
                                InputLabelProps={{ shrink: true }}
                                inputRef={startDateRef}
                              />
                            </Grid>
                          ) : null}
                        </>
                      ) : (
                        <Grid spacing={2} item xs={12} sm={4} md={3}>
                          <Autocomplete
                            size="small"
                            options={Country.getAllCountries().filter((country) => country.name !== 'Canada')}
                            getOptionLabel={(country) => country.name}
                            renderInput={(params) => <TextField {...params} label="Country" variant="outlined" />}
                            onChange={(event, country) => setSelectedCountry(country)}
                          />
                        </Grid>
                      )}
                      <Container>
                        <Box
                          p={3}
                          component={Paper}
                          boxShadow={3}
                          marginBottom={4}
                          marginTop={4}
                          sx={{ border: 0, borderColor: 'primary.main', borderRadius: '16px' }}
                        >
                          <Grid container spacing={3}>
                            <Grid item xs={12}>
                              <TableContainer component={Paper}>
                                <Table size="small">
                                  <TableHead>
                                    <TableRow>
                                      <TableCell>Client's Name</TableCell>
                                      <TableCell>Client's Email</TableCell>
                                      <TableCell>Invoice No</TableCell>
                                      <TableCell>Is in Side Canada</TableCell>
                                      <TableCell>Country</TableCell>

                                      <TableCell>Status</TableCell>
                                      <TableCell>Is Working with Employer</TableCell>

                                      <TableCell>Working with Employer Date</TableCell>
                                      <TableCell>Actions</TableCell>
                                    </TableRow>
                                  </TableHead>
                                  <TableBody>
                                    {clientsForEmp?.map((row, index) => (
                                      <TableRow key={index + 1}>
                                        <TableCell>{row.clientName}</TableCell>
                                        <TableCell>{row.clinetEmail}</TableCell>
                                        <TableCell>{row.invoiceNumber}</TableCell>
                                        <TableCell>{row.isInCanada == true ? 'Yes' : 'No'}</TableCell>
                                        <TableCell>{row.isInCanada == true ? 'Canada' : row.outSideCountry}</TableCell>

                                        <TableCell>{row.status}</TableCell>

                                        <TableCell>{row.isWorkingWithEmployer == true ? 'Yes' : 'No'}</TableCell>
                                        <TableCell>{row?.startDate?.split('T')[0]}</TableCell>

                                        <TableCell>
                                          <IconButton
                                            onClick={() => removeClientsForEmpRow(index)}
                                            aria-label="delete"
                                            size="small"
                                          >
                                            <Trash />
                                          </IconButton>
                                        </TableCell>
                                      </TableRow>
                                    ))}
                                  </TableBody>
                                </Table>
                              </TableContainer>
                            </Grid>
                          </Grid>
                        </Box>
                      </Container>
                    </>
                  ) : null}
                </Grid>
              </Box>
            </Grid>
          </Grid>
        )}

        {saved ? (
          <Snackbar
            anchorOrigin={{ vertical, horizontal }}
            key={vertical + horizontal}
            open={open}
            autoHideDuration={4000}
            onClose={handleClose}
          >
            <Alert elevation={6} variant="filled" onClose={handleClose} severity="success">
              {message}
            </Alert>
          </Snackbar>
        ) : (
          <Snackbar
            key={vertical + horizontal}
            anchorOrigin={{ vertical, horizontal }}
            open={open}
            autoHideDuration={4000}
            onClose={handleClose}
          >
            <Alert elevation={6} variant="filled" onClose={handleClose} severity="error">
              {message}
            </Alert>
          </Snackbar>
        )}
      </Container>
      {checkClient == 'true' ? (
        <Container>
          <Stack direction="row" alignItems="center" justifyContent="space-between" mb={5} marginTop={6}>
            <Typography variant="h4" gutterBottom>
              Client's Info
            </Typography>
          </Stack>
          <ClientDetails />
        </Container>
      ) : (
        <Container>
          <Stack direction="row" alignItems="center" justifyContent="space-between" mb={5} marginTop={6}>
            <Typography variant="h4" gutterBottom>
              Employer's Info
            </Typography>
          </Stack>
          <CompanyDetails />
        </Container>
      )}
      <TasksListAgainstClient />
    </>
  );
}
